import axios from "axios";
import { isEmpty, isObject } from "lodash";

axios.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let retryCount = 0;
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const refresh_token = localStorage.getItem("refreshToken");
    if (error.message === "Network Error" && !originalRequest._retry) {
      if (retryCount >= 5) {
        retryCount = 0;
        localStorage.clear();
        window.location.reload();
        return Promise.reject(error);
      }
      originalRequest._retry = true;
      retryCount += 1;
      try {
        const newResponse = await fetchToken(refresh_token);
        localStorage.setItem("accessToken", newResponse);
        axios.defaults.headers.common["Authorization"] = newResponse;
        console.log("originalRequest", originalRequest);
        return axios(originalRequest);
      } catch (err) {
        if (err.response && err.response.data) {
          return Promise.reject(err.response.data);
        }
        return Promise.reject(err);
      }
    }
    if (error.response) {
      if (error.response.status === 403 && !originalRequest._retry) {
        if (
          error.response.data &&
          error.response.data.message === "Refresh Token Expired"
        ) {
          localStorage.clear();
          window.location.reload();
        }
        if (retryCount >= 5) {
          retryCount = 0;
          localStorage.clear();
          window.location.reload();
          return Promise.reject(error);
        }
        originalRequest._retry = true;
        retryCount += 1;
        try {
          const newResponse = fetchToken(refresh_token);
          axios.defaults.headers.common["Authorization"] = newResponse;
          return axios(originalRequest);
        } catch (err) {
          if (err.response && err.response.data) {
            return Promise.reject(err.response.data);
          }
          return Promise.reject(err);
        }
      }
      if (error.response.status === 403 && error.response.data) {
        return Promise.reject(error.response.data);
      }
    } else if (error.request) {
      console.log("error.request", error.request.status);
    } else {
      console.log("error", error);
    }
    return Promise.reject(error);
  }
);

//login
const login = async (username, password) => {
  return await axios
    .post(
      "sems/token",
      {
        grant_type: "refresh_token",
        user_id: username,
        password: password,
      },
      {
        headers: {
          Authorization: "",
        },
      }
    )
    .then((res) => {
      localStorage.setItem("refreshToken", res.data.data.refresh_token);
      localStorage.setItem("username", username);
      return fetchToken(res.data.data.refresh_token);
      // return (res.data.data.refresh_token);
    })
    .catch((e) => null);
};

const fetchToken = async (token) => {
  return await axios
    .post("sems/token", {
      grant_type: "id_token",
      refresh_token: token,
    })
    .then((res) => {
      localStorage.setItem("accessToken", res.data.data.id_token);
      return res.data.data.id_token;
    });
};

const getDeviceId = (placeId, token, signal) => {
  return axios
    .get("sems/id", {
      params: {
        place: placeId,
      },
      headers: { Authorization: token },
      signal,
    })
    .then((res) => {
      if (isObject(res.data) && !isEmpty(res.data)) {
        return res.data;
      }
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        console.log("Request Canceled");
      } else {
        console.log("err", err);
      }
    });
};

const getDeviceList = (device_id) => {
  return axios
    .post("/get_device_list", {
      device_id: device_id,
    })
    .then((res) => {
      if (isObject(res.data.devices) && !isEmpty(res.data.devices)) {
        return res.data.devices;
      }
    })
    .catch((err) => console.log(err));
};

const getDeviceConfig = (authToken, semsId, config, signal) => {
  if (typeof semsId === "undefined" || semsId === null) {
    if (config.configType === "address") {
      return null;
    }

    if (config.configType === "network_config") {
      return [];
    }
  }

  let body = {
    sems_device_id: semsId,
    config_type: config.configType,
  };

  if (config.hasOwnProperty("placeId")) {
    body["place_id"] = config.placeId;
  }
  return axios
    .get("place/config", {
      params: {
        sems_device_id: body.sems_device_id,
        config_type: body.config_type,
      },
      headers: { Authorization: authToken },
      signal,
    })
    .then((res) => {
      if (isObject(res.data) && !isEmpty(res.data)) {
        if (res.data.hasOwnProperty("time")) {
          if (config.configType === "network_config") {
            if (
              Array.isArray(res.data.devices) &&
              res.data.devices.length > 0
            ) {
              return res.data.devices;
            } else {
              return [];
            }
          }

          if (config.configType === "address") {
            return res.data;
          }
          if (config.configType === "device_models") {
            if (Array.isArray(res.data.models) && res.data.models.length > 0) {
              return res.data.models;
            } else {
              return [];
            }
          } else {
            return null;
          }
        }
      }
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        console.log("Request Canceled");
      }
      if (config.configType === "network_config") {
        return [];
      }

      if (config.configType === "address") {
        return null;
      }
      return null;
    });
};

const getPlaceInfo = (token, signal) => {
  return axios
    .get("sems/places", {
      headers: { Authorization: token },
      signal,
    })
    .then((res) => {
      if (res.data.hasOwnProperty("place_info")) {
        const placeInfo = res.data.place_info;
        if (Array.isArray(placeInfo) && placeInfo.length > 0) {
          return placeInfo;
        }
      }
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        console.log("Request canceled");
      }
      return [];
    });
};

const getElectricityInfo = (
  token,
  deviceId,
  { device_name, device_type_id, device_id },
  signal
) => {
  if (deviceId === null) {
    return null;
  }

  return axios
    .get("place/data/individual", {
      params: {
        sems_device_id: deviceId,
        device_id: device_id,
        device_type: device_name,
      },
      headers: { Authorization: token },
      signal,
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        console.log("Request Canceled");
      }
    });
};

const updateDeviceConfig = (semsId, config, postalCode, address) => {
  return axios
    .post("place/update_device_config", {
      sems_device_id: semsId,
      config_type: config.configType,
      updates: {
        place_id: config.placeId,
        postal_code: postalCode,
        address: address,
      },
    })
    .then(() => {
      return { status: true, message: "住所設定を更新しました。" };
    })
    .catch(() => ({ status: false, message: "住所設定更新を失敗しました。" }));
};

const getNetworkInfo = (deviceId) => {
  return axios
    .post("place/get_network_electricity_info", {
      sems_device_id: deviceId,
    })
    .then((res) => {
      if (res.data.hasOwnProperty("sum_generating")) {
        return res.data;
      }
      return null;
    })
    .catch(() => null);
};

const getHistoryData = (token, daterange, formatDate, deviceId, signal) => {
  return axios
    .get("place/data/history", {
      params: {
        sems_device_id: deviceId,
        date: formatDate,
        period: daterange,
      },
      headers: {
        Authorization: token,
      },
      signal,
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        console.log("Request Canceled");
      }
      console.log("get history info err ---- ", err);
    });
};

const getHistoryDataCsv = (
  token,
  period,
  formatdate,
  deviceId,
  content,
  output
) => {
  return axios
    .get("/place/data/csv", {
      params: {
        sems_device_id: deviceId,
        date: formatdate,
        period: period,
        content: content,
        output_format: output,
      },
      headers: {
        Authorization: token,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => console.log("err", err));
};

const getWeatherData = (token, deviceId, placeId, signal) => {
  return axios
    .get("place/data/weather", {
      params: {
        place_id: placeId,
        sems_device_id: deviceId,
      },
      device_type_id: "W1",
      device_id: "*",
      headers: { Authorization: token },
      signal,
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        console.log("Request Canceled");
      }
    });
};

const getEventInfo = (
  authToken,
  semsId,
  dateFrom,
  dateTo,
  markerId,
  deviceModel,
  eventType,
  signal
) => {
  return axios
    .get(`place/data/events`, {
      params: {
        sems_device_id: semsId,
        datetime_from: dateFrom,
        datetime_until: dateTo,
        marker_id: markerId,
        device_model_no:
          deviceModel && deviceModel.length > 0 ? deviceModel.join(",") : "",
        device_id: "",
        event_type:
          eventType && eventType.length > 0 ? eventType.join(",") : "",
      },
      headers: { Authorization: authToken },
      signal,
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        console.log("Request Canceled");
      }
    });
};

const getAnnouncements = (token, placeId) => {
  return axios
    .get(
      "place/announcements",
      {
        /// Prod Endpoint
        // return axios.get('https://q0y6zwaoj3.execute-api.ap-northeast-1.amazonaws.com/dev/place/announcements', {  ///Dev Endpoint
        params: {
          place_id: placeId,
        },
      },
      {
        headers: { Authorization: token },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => console.log(err));
};

const getCurrentData = async (token, deviceId, signal) => {
  return await axios
    .get("place/data/power", {
      params: {
        sems_device_id: deviceId,
      },
      headers: {
        Authorization: token,
      },
      signal,
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        console.log("Request Canceled");
      }
      return err;
    });
};

const getContacts = async (token, groupId, signal) => {
  return await axios
    .get(`sems/contacts/${groupId}`, {
      headers: { Authorization: token },
      signal,
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        console.log("Request Canceled");
      } else {
        console.log("err", err);
      }
    });
};

const addContact = async (token, groupId, email, username) => {
  return await axios
    .post(
      `sems/contacts/${groupId}`,
      {
        email: email,
        user_name: username,
      },
      {
        Authorization: token,
      }
    )
    .then((res) => {
      if (
        res.data.hasOwnProperty("contact_user") &&
        res.data.contact_user !== null
      ) {
        return true;
      } else {
        return false;
      }
    })
    .catch((err) => {
      return false;
    });
};

const updateContact = async (token, groupId, email, username, id) => {
  return await axios
    .put(
      `sems/contacts/${groupId}/${id}`,
      {
        email: email,
        user_name: username,
      },
      {
        Authorization: token,
      }
    )
    .then((res) => {
      if (
        res.data.hasOwnProperty("contact_user") &&
        res.data.contact_user !== null
      ) {
        return true;
      } else {
        return false;
      }
    })
    .catch((err) => {
      return false;
    });
};

const deleteContact = async (token, groupId, email, username, id) => {
  return await axios
    .delete(
      `sems/contacts/${groupId}/${id}`,
      {
        email: email,
        user_name: username,
      },
      {
        Authorization: token,
      }
    )
    .then((res) => {
      if (
        res.data.hasOwnProperty("contact_user") &&
        res.data.contact_user !== null
      ) {
        return true;
      } else {
        return false;
      }
    })
    .catch((err) => {
      return false;
    });
};

const remoteControl = async (token, device_id, pageSize, signal, marker) => {
  let url = `https://webapi.ss-sems.net/jobs/${device_id}?pageSize=${pageSize}`;
  if (typeof marker !== "undefined" && marker !== null) {
    // Serialize the marker object to a JSON string
    const markerString = JSON.stringify(marker);
    // Encode the serialized string to be safe in a URL
    const encodedMarker = encodeURIComponent(markerString);
    url += `&marker=${encodedMarker}`;
  }
  return await axios
    .get(url, {
      headers: { Authorization: token },
      signal,
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        console.log("Request Canceled");
      }
      return err;
    });
};

const addRemoteControl = async (token, data) => {
  return axios
    .post("https://webapi.ss-sems.net/jobs/", data, {
      headers: {
        Authorization: token,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

const deleteRemoteControl = async (token, device_id, job_id) => {
  return await axios
    .delete(`https://webapi.ss-sems.net/jobs/${device_id}/${job_id}`, {
      headers: { Authorization: token },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

const UpdateRemoteControl = async (token, data) => {
  return axios
    .put("https://webapi.ss-sems.net/jobs/", data, {
      headers: {
        Authorization: token,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export {
  login,
  getDeviceId,
  getDeviceList,
  getElectricityInfo,
  getPlaceInfo,
  getDeviceConfig,
  updateDeviceConfig,
  getNetworkInfo,
  getHistoryData,
  getWeatherData,
  getEventInfo,
  getAnnouncements,
  getCurrentData,
  getContacts,
  addContact,
  updateContact,
  deleteContact,
  getHistoryDataCsv,
  remoteControl,
  addRemoteControl,
  deleteRemoteControl,
  UpdateRemoteControl,
};
